
import * as types from './action-types';

const eventTrackerState = {
  track: false,
  eventData: null,
  eventName: null
};

export default function reducer(
  state = eventTrackerState,
  action
) {
  const { payload } = action;

  switch (action.type) {
    case types.TRACK_PURCHASE_UI: {
      const { data, name } = payload;
      return {
        eventData: data || null,
        eventName: name,
        track: true
      };
    }

    case types.TRACKED:
      return {
        ...eventTrackerState
      };

    default:
      return state;
  }
}

export const Initialize = registry => registry.register('eventTracking', reducer, eventTrackerState);
